/**
 * Categories are free text, and the column's collation is case-insensitive, so
 * "Creative" and "creative" are one category. The first spelling seen labels it.
 *
 * The table's banners and the role modal's suggestion list both read this one
 * rule: if they disagreed, the table would merge two spellings into a single
 * group while the picker still offered both — which is how a third spelling
 * gets created.
 */
export function categoryKey(category) {
    return (category ?? '').toLowerCase();
}

/**
 * @param {Array<{category: string}>} roles
 * @returns {Array<string>} one entry per category, in first-seen order
 */
export function uniqueCategories(roles) {
    const seen = new Map();

    roles.forEach((role) => {
        const key = categoryKey(role.category);

        if (!seen.has(key)) {
            seen.set(key, role.category);
        }
    });

    return Array.from(seen.values());
}
